import { envHelper } from "../utils/envHelper";
import { appendFileExtension, hasExtension } from "../utils/path";

class HtmlAudioLoader {
  key = "audio";

  async load(assetsPath) {
    return new Promise((resolve, reject) => {
      const allowedExtension = envHelper.getAudioSupportedExtension();
      const url = hasExtension(assetsPath)
        ? assetsPath
        : appendFileExtension(assetsPath, allowedExtension);

      const sourceElement = document.createElement("audio");
      sourceElement.setAttribute("src", url);
      sourceElement.setAttribute("volume", "0");

      const handleCanPlay = () => {
        sourceElement.removeEventListener("canplay", handleCanPlay);

        sourceElement.currentTime = 0;
        sourceElement.pause();

        resolve({
          content: sourceElement,
          representation: {
            duration: sourceElement.duration,
          },
        });
      };

      sourceElement.addEventListener("canplay", handleCanPlay);
      sourceElement.addEventListener("error", reject);
      sourceElement.play();
    });
  }
}

const htmlAudioLoader = new HtmlAudioLoader();
export { htmlAudioLoader, HtmlAudioLoader };
